import { required, helpers } from '@vuelidate/validators';
import { computed, ref } from 'vue';

import config from '@/config';

export const phoneOrEmpty = helpers.withMessage('Invalid phone number', (value: string) => {
  return !value || /^\+[1-9]\d{7,14}$/.test(value);
});

export const getProfileFieldValidationKeys = (fieldName: string, validationKeys: string[]): string[] => {
  if (fieldName !== 'phoneNumber') return validationKeys;
  return [...new Set([...validationKeys, 'phoneOrEmpty'])];
};

export function useProfileFieldsValidation(
  savedFields: Record<string, string> = {},
  additionalFields: Record<string, string[]> = {},
) {
  const configFields = {
    ...additionalFields,
    ...config.profileFields,
  };
  const profileFields = Object.fromEntries(Object.keys(configFields).map(x => [x, ref(savedFields[x] || '')]));
  const hasLetter = helpers.withMessage('Must have at least one letter', (value: string) => {
    // Allow empty values or values that match the regex
    return /[a-zA-Z]/.test(value);
  });

  const validations: Record<string, unknown> = {
    phoneOrEmpty,
    required,
    hasLetter,
  };
  const rules = computed(() => ({
    ...Object.fromEntries(Object.entries(configFields)
      .map(([key, validationKeys]) => {
        return [
          key,
          Object.fromEntries(
            getProfileFieldValidationKeys(key, validationKeys as string[])
              .filter(validationKey => validationKey in validations)
              .map(validationKey => [validationKey, validations[validationKey]]),
          ),
        ];
      })),
  }));

  return {
    rules,
    profileFields,
    profileKeys: Object.keys(configFields),
  };
}
